import { createContext } from 'react';
import getTextStore from './core/getTextStore/index';
import getWithText from './core/getWithText/index';
var create = function create() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _settings$hocs = settings.hocs,
    hocs = _settings$hocs === void 0 ? {} : _settings$hocs;
  var _createContext = createContext({}),
    Provider = _createContext.Provider,
    Consumer = _createContext.Consumer;
  var TextStore = getTextStore({
    Provider: Provider
  });
  var withText = getWithText({
    Consumer: Consumer,
    hocs: hocs
  });
  return {
    TextStore: TextStore,
    withText: withText
  };
};
export default create;